/*
 * @file RegionsListSelector/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 * @author Fitore Jaha [fitore.jaha@cbc.ca]
 */

export const ARIA_MENU = {
    inactive: {
        "aria-hidden": true,
    },
    active: {
        "aria-hidden": false,
    },
};

export const PLACEMENT = {
    SIDEBAR: "sidebar",
    MEGAMENU: "megamenu",
    CONTENT: "content",
    PREFERENCES: "preferences",
};

export const SET_YOUR_LOCAL_BUTTON_LABEL = "Set your local region";
